import { render, staticRenderFns } from "./ExpeditionTable.vue?vue&type=template&id=4e00f2f9&"
import script from "./ExpeditionTable.vue?vue&type=script&lang=js&"
export * from "./ExpeditionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports